export default {
  // Режими
  "common.mode.auto": "Самогенериране и самопотребление",
  "common.mode.economy": "Икономически режим",
  "common.mode.exigency": "Авариен режим",

  // Устройства
  "common.grid": "Електрическа мрежа",
  'common.evChargers': 'Зарядни станции',
  'common.evCharger': 'Зарядна станция',
  'common.pv': 'Фотоволтаици',
  'common.inverter': 'Инвертор',
  'common.pcs': 'Инвертор + батерия',
  'common.terminal': 'Крайно устройство',
  'common.airc': 'Климатик',
  'common.engine': 'Двигател',
  'common.battery': 'Батерия',
  'common.metter': 'Електромер',
  'common.other': 'Друго',
  "common.power": "Мощност",
  "common.powerTotal": "Обща мощност",
  "common.voltage": "Напрежение",
  "common.electricity": "Електричество",
  "common.current": "Ток",
  "common.homeUsage": "Общо домашно натоварване",
  "common.battery.power": "Мощност на батерията",

  // Данни
  "common.noDataAvailable": 'Няма налични данни в момента~',
  'common.tips': 'Съвети',
  "common.reset": "Нулиране",
  "common.currencyUnit": 'лв',
  "common.submiting": 'Изпращане, моля изчакайте...',
  "common.close": 'Затвори',
  "common.from": 'От',
  "common.useIn": 'Използва се за',
  "common.energyPercent": 'Дял на енергийния поток',
  "common.dataFlow": "Поток от данни",
  "common.getDataIng": 'Получаване на данни, моля изчакайте...',
  "common.pageLoading": 'Съдържанието на страницата се зарежда, моля изчакайте...',
  "common.reseting": "Нулиране на съдържанието на страницата, моля изчакайте...",
  "common.save": 'Запази',
  "common.onlyNumberTips": "Може да се попълват само числа",
  "common.offline": "Офлайн",
  "common.online": "Онлайн",
  "common.fault":"Неизправност",
  "common.charge": "Зареждане",
  "common.discharge": "Разреждане",
  "common.buy": "Купуване",
  "common.sell": "Продажба",
  "common.loadingInfo": 'Зареждане, моля изчакайте...',

  // 
  "common.moreFeatures": "Още функции",
  "common.confirm": 'Потвърди',
  "common.saveing": "Запазване, моля изчакайте...",
  "common.searchPlacholder": "Моля въведете ключова дума за търсене",
  "common.iSee": 'Разбирам',
  "common.pageErrorTips1": "Опа, има грешка в страницата~",
  "common.pageErrorTips2": "Моля опитайте да презаредите или се свържете с поддръжката~",
  "common.refresh": "Обнови",
  "common.backToHome": "Върни се към началната страница",
  "common.checkTips": "Проверяване, моля изчакайте...",
  "common.back": "Назад",
  "common.cancel": "Отказ",
  "common.optional": "По избор",
  "common.required": "Задължително",
  "common.status": "Статус",
  "common.statusNoDelete": "Неизтрито",
  "common.statusDelete": "Изтрито",
  "common.submit": 'Изпрати',
  "common.disable": "Деактивиране",
  "common.enable": "Активиране",
  "common.year": 'година',
  "common.month": 'месец',
  "common.day": 'ден',
  "common.version": 'Номер на версия：',
  "common.backHome": ' Върни се към началната страница',
  "common.backHomeSorry": ' Съжаляваме, страницата се е загубила по случайност',
  "common.requestTips1": 'Данните се обработват, моля не изпращайте повторно',
  "common.requestTips2": "Системно съобщение",
  "common.requestTips3": "Състоянието на влизане е изтекло, моля влезте отново",
  "common.requestTips4": "Влез отново",
  "common.requestTips5": "Невалидна сесия или сесията е изтекла, моля влезте отново.",
  "common.requestTips6": "Грешка в сървъра, моля опитайте по-късно.",
  "common.requestTips7": "Изтечено време на заявката към системния интерфейс",
  "common.requestTips8": 'Системен интерфейс',
  "common.requestTips9": 'Изключение',
  "common.iknow": 'Разбирам',
  "common.logoutSuccess": "Успешно излизане",
  
  // Компонент за повече информация
  "common.knowMore.title": 'За повече информация, моля свържете се с Норт Енерджи',
  "common.knowMore.email": 'Контактен имейл',
  "common.knowMore.phone": 'Контактен телефон',
  "common.knowMore.wechat": 'Контакт WeChat',
  "common.knowMore.website": 'Официален уебсайт',
  "common.knowMore.address": 'Контактен адрес',
  "common.knowMore.addressDetail": 'Комнати 1205, 1301, Сграда 5, ул. Чинхе 8, Хуангджинкен, Хуангджиан, Донггуан, провинция Гуандон',
  
  // Компонент за локална връзка
  "common.localConnection": 'Локална връзка',
  "common.operateInApp": 'Моля работете в приложението!',
  
  "common.enbleStaus": "Състояние на активиране",
  "common.battery.status": "Нито зареждане, нито разреждане",

  'account.forgetThePassword': 'Забравена парола',
    'account.logInDirectly': 'Отиди директно към влизане',
    'account.tips1': 'Страницата се пренасочва, моля изчакайте...',
    'account.tips2': 'Моля първо прегледайте и се съгласете с потребителските условия!',
    'account.autoLogin': 'Автоматично влизане',
    'account.userLogin': 'Потребителско влизане',
    'account.registerTips': 'Още нямате акаунт? Кликнете тук, за да се регистрирате',
    'account.userEmail': 'Потребителско име/имейл',
    'account.userEmailTips': 'Моля въведете потребителско име/имейл',
    'account.password': 'Парола',
    'account.passwordTips': 'Моля въведете парола',
    'account.submit': 'Изпрати',
    'account.submitTips': 'Изпращане, моля изчакайте...',
    'account.otherLoginTips': 'Или изберете друг начин на влизане',
    'account.userRegistration': 'Потребителска регистрация',
    'account.userName': 'Потребителско име',
    'account.userNameTips': 'Моля въведете потребителско име',
    'account.emailTips1': 'Моля въведете имейл адрес',
    'account.emailTips2': 'Форматът на имейл адреса не е правилен',
    'account.phone': 'Телефонен номер',
    'account.phoneTips1': 'Моля въведете телефонен номер',
    'account.phoneTips2': 'Телефонният номер не е правилен',
    'account.phoneTips3': 'Моля въведете телефонен номер',
    'account.passwordTips1': 'Моля въведете парола от 6-30 символа',
    'account.passwordTips2': 'Неправилен формат на паролата, паролата се състои от английски букви, цифри, долни черти, тирета и точки, дължина 6-12 символа',
    'account.passwordTips3': 'Паролите не съвпадат, моля проверете и въведете отново!',
    'account.passwordTips4': 'Моля въведете парола, паролата се състои от английски букви, цифри, долни черти, тирета и точки',
    'account.passwordTips5': 'Потвърждаване на паролата',
    'account.passwordTips6': 'Моля въведете потвърждение на паролата',
    'account.passwordTips7': 'Паролите не съвпадат, моля проверете и въведете отново!',
    'account.passwordTips8': 'Моля въведете потвърждение на паролата',
    'account.passwordTips9': 'Поздравления за успешната регистрация!',
    'account.passwordTips10': 'Вашето потребителско име е:',
    'account.emailIs': 'Имейлът е:',
    'account.goToLoginPage': 'след s секунди ще се пренасочите автоматично към страницата за влизане',
    'account.goLogin': 'Отиване към влизане',
    'account.goRegister': 'Регистрация',
    'account.loginSuccess': 'Успешно влизане',
    'account.email': 'Имейл',
    'account.sologn': 'Отдадено създаване на енергийни решения, прилагодени към вас',
    'account.pleaseAgree': 'Прочетох и се съгласявам с',
    'userAgreement.privacyPolicy': 'Политика за поверителност',

    "account.code": "Код за потвърждение",
    "account.codeTips": "Моля въведете код за потвърждение",
    "account.codeTips2": "Кодът за потвърждение не е правилен",

    "account.inviteCodeTips": "Моля, въведете код за покана",
    "account.inviteCodeHint": "Моля, свържете се с монтажника или персонала по поддръжка, за да получите код за покана",
    "account.modifyPasswordByAccount": "Промяна на парола чрез акаунт",
    "account.modifyPasswordByEmail": "Промяна на парола чрез имейл",
    "account.getPasswordByAccount": "Възстановяване на парола чрез акаунт",
    "account.getPasswordByEmail": "Възстановяване на парола чрез имейл",

    "account.sendEmailTips": "Кодът за потвърждение е изпратен на имейл адреса, моля проверете пощата си",
    "account.name": "Име на акаунта",
    "account.newPassword": "Нова парола",
    "account.confirmNewPassword": "Потвърдете новата парола",
    "account.nameTips": "Моля въведете името на акаунта",
    "account.passwordModifySuccess": "Паролата е променена успешно",
    "account.emailCode": "Код за потвърждение по имейл",
    "account.emailCodeTips": "Моля въведете кода за потвърждение по имейл",
    "account.emailCodeTips2": "Кодът за потвърждение по имейл не е правилен",
    "account.emailModifySuccess": "Паролата е променена успешно",
    "account.passworTips1": "Вашата парола е нулирана успешно!",
    "account.passwordTips11": "Моля въведете потвърждение на паролата",
    "account.passwordTips12": "Моля въведете нова парола",
    "account.nickname": "Потребителски псевдоним",
    "account.modifyNickname": "Промяна на потребителския псевдоним",
    "account.modifyNicknameSuccess": "Потребителският псевдоним е променен успешно!",
    "account.nicknameTips": "Моля въведете потребителски псевдоним",
    'account.nicknameError': 'Неуспешна промяна на потребителския псевдоним!',

    "account.login": 'Вход',
    'account.quickRegister': 'Бърза регистрация',
    'account.sendCode': 'Изпрати код за потвърждение',
    'account.sendTips': 'Може да се изпрати отново след s секунди',
    "account.sendEmailIng": 'Изпраща се имейл, моля изчакайте...',
    'account.emailNotEmpty': 'Имейл адресът не може да бъде празен',
    'account.registerAccount': 'Регистрация на акаунт',
    'account.registerWelcome': 'Добре дошли в SusprSafe',
    'account.usernameLimit': 'Потребителското име може да започва само с буква и да съдържа само букви, цифри и долни черти, дължина между 5-15 символа',

    'copyright.desc2': 'Информация за регистрацията на уебсайта：粤ICP备2021169764号',

    'editUserInfo.editUserInformation': 'Редактиране на потребителска информация',
    'editUserInfo.modifyUsername': 'Промяна на потребителското име',
    'editUserInfo.changePictures': 'Промяна на аватара',
    'editUserInfo.savePicturesSuccess': 'Аватарът на потребителя е запазен успешно',
    'editUserInfo.saveError': 'Неуспешно запазване',
    'editUserInfo.pictureLimit':'Изображението трябва да бъде под 2MB',
    'editUserInfo.uploadPicture':'Качване на аватар',
    'editUserInfo.picturePreview':'Преглед',
    
    'editUserInfo.bindPhoneNumber': 'Свързване на телефонен номер',
    'editUserInfo.bindEmail': 'Свързване на имейл',
    'editUserInfo.changePassword': 'Промяна на парола',

    'editUserInfo.notificationSettings': 'Настройки за уведомления',
    'editUserInfo.editAccount': 'Редактиране на информацията за потребителския акаунт',
    'editUserInfo.waitBingting': 'Свързване, моля изчакайте...',
    'editUserInfo.collapse': 'Свий',
    'editUserInfo.modifyBinding': 'Промяна на свързването',
    
    'editUserInfo.emailAddress': 'Имейл адрес',
    'editUserInfo.tips1': 'Имейлът е свързан успешно',
    'editUserInfo.tips2': 'Неуспешно запазване',
    'editUserInfo.tips3': 'Изпраща се код за потвърждение по имейл, моля изчакайте...',
    'editUserInfo.tips4': 'Кодът за потвърждение е изпратен на имейл xxxx, моля проверете',
    'editUserInfo.tips5': 'Неуспешно изпращане на код за потвърждение!',
    'editUserInfo.tips6': 'Телефонният номер е вече свързан',
    'editUserInfo.tips7': 'Имейлът е вече свързан',
    'editUserInfo.emailTips1': 'Моля въведете имейл адрес',
    'editUserInfo.emailTips2': 'Форматът на имейл адреса не е правилен',
    'editUserInfo.emailTips3': 'Може да се изпрати отново след xxxxs',
    'editUserInfo.emailTips4': 'Изпрати код',
    'editUserInfo.emailTips5': 'Кодът за потвърждение по имейл не може да бъде празен',
    'editUserInfo.emailTips6': 'Кодът за потвърждение по имейл не е правилен',
    'editUserInfo.emailCode': 'Код за потвърждение по имейл',
    'editUserInfo.save': 'Запази',

    'editUserInfo.phoneTips1': 'Телефонният номер е свързан успешно',
    'editUserInfo.phoneTips2': 'Изпраща се код за потвърждение по телефон, моля изчакайте...',
    'editUserInfo.phoneTips3': 'SMS код за потвърждение е изпратен на телефон xxxx, моля проверете',
    'editUserInfo.phoneTips4': 'Неуспешно изпращане на SMS код за потвърждение!',
    'editUserInfo.phoneTips5': 'Моля въведете телефонен номер',
    'editUserInfo.phoneTips6': 'Форматът на телефонния номер не е правилен',
    'editUserInfo.phoneTips7': 'Изпращане на SMS код за потвърждение',
    'editUserInfo.phoneTips8': 'SMS код за потвърждение',
    'editUserInfo.phoneTips9': 'Кодът за потвърждение по телефон не може да бъде празен',
    'editUserInfo.phoneTips10': 'Кодът за потвърждение по телефон не е правилен',
    'editUserInfo.phone': 'Телефонен номер',


    'editUserInfo.noticeTips1': 'Неуспешно получаване на настройки за уведомления!',
    'editUserInfo.noticeTips2': 'Настройките за уведомления са запазени успешно!',
    'editUserInfo.noticeTips3': 'Уведомление за ниска батерия',
    'editUserInfo.noticeTips4': 'Уведомление за завършване на зарядката',
    'editUserInfo.errorNotification': 'Уведомления за грешки',
    'editUserInfo.updateNotification': 'Уведомления за актуализации',
    'editUserInfo.monthlyStatisticsNotification': 'Месечни статистически уведомления',
    'editUserInfo.notificationMethod': 'Метод за получаване',

    'editUserInfo.userNameTips1': 'Потребителското име е запазено успешно',
    'editUserInfo.userNameTips2': 'Неуспешно запазване на потребителското име',
    'editUserInfo.userNameTips3': 'Моля въведете потребitelско име',
    'editUserInfo.userNameTips4': 'Неправилен формат на потребителското име, трябва да се състои от цифри, долни черти и английски букви',
    'editUserInfo.userNameTips5': 'Моля въведете потребителско име',
    'editUserInfo.userNameTips6': 'Запазване, моля изчакайте...',
    'editUserInfo.userName': 'Потребителско име',

    'editUserInfo.avatorTips': 'Кликнете за промяна на аватара',
    'editUserInfo.verifyCodeTips1': 'Моля въведете кода за потвърждение, който получихте:',
    'editUserInfo.verifyCodeTips2': 'За сигурността на акаунта ви, моля кликнете на бутона по-долу, за да изпратите код за потвърждение на оригиналния телефонен номер:',
    'editUserInfo.verifyCodeTips3': 'Изпрати код',
    'editUserInfo.verifyCodeTips4': 'Оригиналният телефон е потвърден, моля въведете новия телефонен номер за свързване',
    'editUserInfo.verifyCodeTips5': 'За сигурността на акаунта ви, моля кликнете на бутона по-долу, за да изпратите код за потвърждение на оригиналния имейл:',
    'editUserInfo.verifyCodeTips6': 'Оригиналният имейл е потвърден, моля въведете новия имейл',
    'editUserInfo.verifyCodeTips7': 'Стара парола',
    'editUserInfo.verifyCodeTips8': 'Моля първо свържете имейл!',
    'editUserInfo.verifyCodeTips9': 'Кодът за потвърждение е изпратен на имейла, моля проверете пощата си',
    "editUserInfo.verifyCodeTips10": ', ще се пренасочите автоматично към страницата за влизане',

    "hems.notice.title": "Заглавие на уведомлението", 
   "hems.notice.content": "Съдържание на уведомлението", 
   "hems.notice.operate": "Операция",
   "hems.notice.noRead": "Непрочетено",
   "hems.notice.read": "Прочетено",
   "hems.notice.warning": "Напомняне",
   "hems.notice.error": "Изключение",
   "hems.notice.success": "Статистическо уреждане",
   "hems.notice.sys": "Системна информация",
   "hems.notice.operateSuccess": "Операцията е успешна",
   "hems.notice.operateTips": "Моля изберете елемента за обработка",

    // Начална страница
   "hems.home.selfuseRate": "Процент на самогенериране и самопотребление",
   "hems.home.percent": "Процент",
   "hems.home.todayData": "Днешни данни",
   "hems.home.todayPowerGeneration": "Днешно производство на електричество",
   "hems.home.salesIncome": "Доходи от продажба на електричество",
   "hems.home.saved": "Спестено за вас",
   "hems.home.reduce": "Намаляване на въглеродния отпечатък",
   "hems.home.tips1": "Няма данни, още не сте свързали xxxx",
   "hems.home.criticalLoad": "Критично натоварване",
   "hems.home.keyVoltage": "Критично напрежение",
   "hems.home.householdLoad": "Домашно натоварване",
   "hems.home.householdVoltage": "Домашно напрежение",
   "hems.home.generalLoad": "Обичайно натоварване",
   "hems.home.generalVoltage": "Обичайно напрежение",
   "hems.home.batteryHealth": "Здраве на батерията",
   "hems.home.averageTemp": "Средна температура",
   "hems.home.gridLoad": "Натоварване на мрежата",
   "hems.home.toggeleDataSource": "Текущите показвани данни са превключени към:",
   "hems.home.toggleTips": "Сигурни ли сте, че искате да превключите?",
   "hems.home.modeSending": "Командата за режим се изпраща, моля изчакайте...",
   "hems.home.modeSuccess": "Командата за превключване на режима е изпратена успешно!",
   "hems.home.isOnline": "Онлайн ли е",
   "hems.home.useStatus": "Състояние на използване",
   "hems.home.workModeText": 'Текущ работен режим:',
   "hems.home.toggleDataSourceText": 'Текущите показвани данни са превключени към:',
   "hems.ev.charge.status": "Състояние на зареждане",
   "hems.ev.charge.time": "Продължителност на зареждането",
   "hems.ev.charge.count": "Количество зареждане в реално време",
   "hems.ev.charge.status.empty":"Празно",
   "hems.ev.charge.status.ing":"Зареждане с пистолет",
   "hems.ev.charge.status.null":"Пистолет включен, но не зарежда",
   "hems.ev.charge.status.error":"Неизправност",
   "hems.hour":"час",
   "hems.minue":"минута",
   "hems.ev.chagre.number": "Номер на зарядната станция",

   // Ръководство за потребителя
   "hems.userGuide.selfUse": "Самогенериране и самопотребление",
   "hems.userGuide.selfUseTips": "Приоритетно използване на фотоволтаично генериране, допълване от мрежата при недостиг",
   "hems.userGuide.economyMode": "Икономически режим",
   "hems.userGuide.economyModeTips": "Оптимизиране на стратегията за употреба на електричество въз основа на цените",
   "hems.userGuide.emergencyMode": "Авариен режим",
   "hems.userGuide.emergencyModeTips": "Приоритетно осигуряване на захранване на критичните натоварвания",

   // Страница с графики
   "hems.history.energyStatistics": "Статистики за енергия",
   "hems.history.revenueStatistics": "Статистики за доходи",
   "hems.history.greenStatistics": "Зелена редукция на емисиите",
   "hems.history.revenueTitle": "Общи доходи от продажба на електричество",
   "hems.history.savingsTitle": "Общи спестявания",
   "hems.history.carbonTitle": "Общо намаляване на въглеродните емисии",
   "hems.history.day": "ден",
   "hems.history.month": "месец",
   "hems.history.year": "година",
   "hems.history.beforeDay": "предишния ден",
   "hems.history.afterDay": "следващия ден",
   "hems.history.beforeMonth": "предишния месец",
   "hems.history.afterMonth": "следващия месец",
   "hems.history.beforeYear": "предишната година",
   "hems.history.afterYear": "следващата година",
   "hems.history.totalUse": 'Общо използване',
   "hems.history.fullScreen": 'Цял екран',
   "hems.history.timeSelect": "Избор на дата",
   "sync.tips1": "Командата за синхронизиране на данните е изпратена успешно!",
   "sync.tips2":"Синхронизирането на данните е в процес, поради големия обем данни процесът отнема време, моля проверете отново след половин час~",
   "sync.tips3": "Синхронизирането на данните на устройството може да се забави, ако откриете аномалии в данните, моля кликнете:",
   "sync.tips4": "Синхронизиране на данни",

   "charge.info": "Информация за зарядната станция",
    "news.loading": 'Зарежда се...',
    "news.noMore": 'Няма повече',
    "hems.pv.power": 'Фотоволтаично захранване',

  // UEH специфично
  "ueh.sellPower": "Количество продадено електричество",
  
  "menu.home": "Начална страница",
  "menu.history": "Исторически данни",
  "menu.device": "Устройство",
  "menu.settings": "Настройки",
  "menu.messageCenter": "Център за съобщения",
  "menu.help": "Помощ и поддръжка",
  "menu.mine": "Моят",


  "mine.userSetting": "Потребителски настройки",
  "mine.terminalSetting": "Основни настройки на терминала",
  "mine.uploadCloud": "Резервно копие на данни в облака",
  "mine.changeVersion": "Проверка за актуализации",
  "mine.language": "Смяна на език",
  "mine.about": "За",
  "mine.feedback": "Мнения и обратна връзка",
  "mine.logout": "Излизане",
  "mine.logoutAccount": "Изтриване на акаунт",

  "mine.logoutAccountTips": "Изтриване на акаунта с име []",
  "mine.logoutAccountTips1": "Изтриване на акаунта свързан с []",
  "mine.logoutAccountCare": "Свързани въпроси при заявката за изтриване:",
  "mine.logoutAccountCare1": "1. Акаунтът е в безопасно състояние",
  "mine.logoutAccountCare1-1": "Акаунтът в момента е в нормално състояние за използване, няма рискове като кражба, нарушение, забрана и др.",
  "mine.logoutAccountCare2": "2. Упълномощаването и свързването на акаунта са прекратени",
  "mine.logoutAccountCare2-1": "Акаунтът е прекратил упълномощаването с други платформи на трети страни и др.",
  "mine.logoutAccountCare3": "3. Акаунтът не може да бъде възстановен след изтриване, всички потребителски данни се изтриват",
  "mine.logoutAccountCare3-1": "След изтриването на акаунта, свързаният мобилен телефон, имейл и други акаунти и свързани данни се изтриват и не могат да бъдат възстановени.",
  "mine.confirmLogout": "Потвърждаване на изтриването",
  "mine.logoutSuccess": "Акаунтът е изтрит успешно!",


  "mine.feedbackIssues": "Съобщаване за проблем",
  "mine.feedQuantity": "Количество",
  "mine.feedAmount": "Максимум 9 изображения, максимум 1MB на изображение",

  "mine.notice.fail": "Неуспешно получаване на настройки за уведомления!",
  "mine.notice.saveSuccess": "Настройките за уведомления са запазени успешно!",
  "mine.notice.saveFail": "Неуспешно запазване!",
  "mine.notice.title": "Настройки за уведомления",
  "mine.notice.batteryLow": "Уведомление за ниска батерия",
  "mine.notice.chargingFinish": "Уведомление за завършване на зарядката",
  "mine.notice.error": "Уведомления за грешки",
  "mine.notice.update": "Уведомления за актуализации",
  "mine.notice.monthly": "Месечни статистически уведомления",
  "mine.notice.receiveType": "Метод за получаване",

  "mine.language.welcome": "Добре дошли в SusprSafe",
  "mine.language.desc1": "Моля задайте езиковата версия според вашия регион",
  "mine.language.desc2": "Можете да променяте по всяко време чрез настройките на приложението",

  "mine.userInfo.avatar":"Аватар",
  "mine.userInfo.nickname":"Псевдоним",
  "mine.userInfo.password":"Парола",
  "mine.userInfo.changePassword":"Промяна на парола",
  "mine.userInfo.setPassword":"Задаване на парола",
  "mine.userInfo.phoneNumber":"Телефонен номер",
  "mine.userInfo.bindPhone":"Свързване на телефонен номер",
  "mine.userInfo.bindEmail":"Свързване на имейл",
  "mine.loginExpired":"Влизането е изтекло, моля влезте отново",
  "mine.userInfo.title":"Потребителска информация",
  "mine.userInfo.bind":"Свързване",
  "mine.userInfo.modify": "Промяна",
  "mine.userInfo.modifyNickname":"Промяна на псевдоним",
  "mine.userInfo.userNickname":"Потребителски псевдоним",
  "mine.userInfo.selectPic":"Моля изберете изображение за качване",
  "mine.userInfo.saveSuccess":"Запазено успешно",
  "mine.userInfo.uploadFail":"Неуспешно качване",
  "mine.userInfo.avatarSaveSuccess":"Аватарът е запазен успешно",
  "mine.userInfo.nameTips1":"Потребителският псевдоним не може да бъде празен",
  "mine.userInfo.nameTips2":"Моля въведете потребителски псевдоним",

  "common.pleaseSelect": "Моля изберете",
  "question.commonQuestions": "Често задавани въпроси",
  "account.toggleLanguage": 'Смяна на език',
  "account.localConnection": "Локална връзка",
  "account.selectLanguage": 'Моля изберете език',
  "account.sendEmailToast": "Кодът за потвърждение е изпратен на имейл xxx, моля проверете пощата си",
  "account.emailError": "Форматът на имейла не е правилен",
  "account.sendEmailFail": "Неуспешно изпращане, моля опитайте отново",
  
  "common.submitting": "Изпращане, моля изчакайте...",

  "device.page.noData": "Няма данни, тази страница може да се преглежда само в приложението"
 
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};